// extracted by mini-css-extract-plugin
export var fullWidthButton = "_o5-0";